import styled from 'styled-components';
import { rem } from 'polished';
import { ModalDemoVehicleInfoTemplate } from './ModalDemoVehicleInfoTemplate';

export const ModalDemoVehicleInfoStyled = styled(ModalDemoVehicleInfoTemplate)`
    .section {
        margin: ${rem(20)} 0 ${rem(40)} 0;
    }
`;
